/**
 * Collision tests used by the board mutations to keep spanning parts from overlapping.
 *
 * The accommodation strip allows at most one booking per night; the services strip allows at most one
 * service per (day, lane). These helpers answer "is this slot already taken?" while ignoring the part
 * currently being moved (`ignoreUid`).
 */
import type { BoardPart } from '../model';

/** True when some accommodation booking (other than `ignoreUid`) already covers `nightIdx`. */
export function nightCovered(parts: BoardPart[], nightIdx: number, ignoreUid?: string): boolean {
  return parts.some(
    (p) =>
      p.kind === 'accommodation' &&
      p.uid !== ignoreUid &&
      nightIdx >= p.day &&
      nightIdx < p.day + p.span
  );
}

/** True when some service (other than `ignoreUid`) already covers `dayIdx` on lane `row`. */
export function serviceCovered(
  parts: BoardPart[],
  dayIdx: number,
  row: number,
  ignoreUid?: string
): boolean {
  return parts.some(
    (p) =>
      p.kind === 'service' &&
      p.uid !== ignoreUid &&
      (p.row ?? 0) === row &&
      dayIdx >= p.day &&
      dayIdx < p.day + p.span
  );
}
